import { ref, onUnmounted } from 'vue'
import { getEcho, initEcho } from '@/services/echo'
import { useAuthStore } from '@/stores/auth'
import { useBrowserNotifications } from '@/composables/useBrowserNotifications'
import { useRouter } from 'vue-router'

export function useRealtimeNotifications() {
  const latestNotification = ref(null)
  const router = useRouter()
  let channel = null

  function showDesktopNotif(notif) {
    const { show, permission } = useBrowserNotifications()
    console.log('[Pusher] Received notification:', notif, '| Permission:', permission())
    if (permission() !== 'granted') return

    const n = show(notif.title || 'New notification', {
      body: notif.message || '',
      tag: `notif-${notif.id}`,
      data: { action_url: notif.action_url, id: notif.id },
    })

    if (n) {
      console.log('[Pusher] Desktop notification shown:', notif.title)
      n.onclick = () => {
        n.close()
        window.focus()
        if (notif.action_url) {
          router.push(notif.action_url)
        }
      }
    } else {
      console.warn('[Pusher] Failed to show desktop notification')
    }
  }

  function subscribe() {
    const authStore = useAuthStore()
    authStore.initAuth()
    const user = authStore.user
    const token = authStore.token

    if (!user || !token) {
      console.warn('[Pusher] Cannot subscribe: no user or token')
      return
    }

    if (user.notifications_realtime === false) {
      console.log('[Pusher] Realtime notifications disabled for user', user.id)
      return
    }

    console.log('[Pusher] Subscribing user:', user.id)

    initEcho(token)
    const echo = getEcho()
    if (!echo) {
      console.warn('[Pusher] Echo not initialized (Pusher key missing?)')
      return
    }

    console.log('[Pusher] Echo initialized, subscribing to user.' + user.id)

    channel = echo.private(`user.${user.id}`)

    channel.listen('.notification.created', (data) => {
      console.log('[Pusher] Event received:', data)
      latestNotification.value = { ...data }
      showDesktopNotif(data)
    })
  }

  function unsubscribe() {
    if (channel) {
      channel.stopListening('.notification.created')
      channel.unsubscribe()
      channel = null
    }
  }

  onUnmounted(() => {
    unsubscribe()
  })

  return {
    latestNotification,
    subscribe,
    unsubscribe,
  }
}
